import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { isTeacher, isPartnerAdminDashboard } from '../../utils/authScopes';
import { appNamedRoutes } from '../../routes';
import SparklerLogo from '../../../assets/images/sparkler-logo.svg';

const FixedBar = ({ auth, onLogout, onStartASQ }) => {
  const { bgColor, isAuthenticated, logoUrl, name } = auth;
  if (!isAuthenticated) return null;
  const style = bgColor ? { backgroundColor: bgColor } : {};
  const rootUrl = isPartnerAdminDashboard(auth) ? appNamedRoutes.partnerRoot : appNamedRoutes.asqs;
  return (
    <div className="o-navbar cs-bg--sp-black" style={style}>
      <div className="o-navbar__wrap row align-middle">
        <div className="column u-flex align-middle">
          <Link to={{pathname: rootUrl, state: {from: 'navbar'} }} className="o-navbar__logo">
            <img alt='Sparkler' src={logoUrl || SparklerLogo} />
          </Link>
          <div className='u-txt--nav-name u-padding-left--gutter'>{name}</div>
        </div>
        <div className="column text-right">
          { isTeacher(auth) && <a className="o-sp-button o-sp-button--base o-sp-button--primary" onClick={onStartASQ}>Start ASQ</a> }
          <a className="o-sp-button o-sp-button--base o-sp-button--light u-margin-left--base" onClick={onLogout}>Sign Out</a>
        </div>
      </div>
    </div>
  );
}

FixedBar.propTypes = {
  auth: PropTypes.object.isRequired,
  onLogout: PropTypes.func.isRequired,
  onStartASQ: PropTypes.func.isRequired,
}

export default FixedBar;
